export default __webpack_public_path__ + "static/media/youtube-logo.525d4ba6.png";